const swiperChangeSlider = new Swiper('.change-slider__contents', {
  loop: true,
  slidesPerView: 1.52,
  spaceBetween: 12,
  pagination: {
    el: '.change-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: `.swiper-button-next-change`,
    prevEl: `.swiper-button-prev-change`,
    enabled: true,
  },
  breakpoints: {
    580: {
      slidesPerView: 2.55,
    },
  }
});
